// This component is to be passed down as prop to
// the HoneybadgerErrorBoundary component

import type { ReactElement } from 'react';
import styles from './ErrorComponent.module.scss';
import { Button } from 'common/components/Button';

export function ErrorComponent(): ReactElement {
  return (
    <div>
      <p className={styles.errorMessage}>{__('error.something_went_wrong')}</p>
      <Button
        onClick={() => {
          window.location.reload();
        }}
        type="primary"
      >
        {__('error.reload')}
      </Button>
    </div>
  );
}
